import { makeStyles } from "@material-ui/core/styles"
import { IoIosArrowForward } from "react-icons/io"

export const useStyles = makeStyles(theme => ({
  button: ({
    outlined,
    maxWidth,
    borderRadius,
    fontSize,
    fontWeight,
    height,
    marginBottom
  }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "13px",
    width: "100%",
    maxWidth: maxWidth || "252px",
    background: "rgb(0,145,210)",
    background:
      "linear-gradient(90deg, rgba(0,145,210,1) 35%, rgba(71,198,255,1) 100%)",
    color: "#fff",
    borderRadius: borderRadius || 30,
    border: outlined ? "2px solid #fff" : "none",
    outline: outlined ? "1px solid #0091d2" : "none",
    fontSize: fontSize || 16,
    fontWeight: fontWeight || 500,
    height: height || "45px",
    marginBottom: marginBottom || 0
  })
}))

export default function CheckoutButton({
  children,
  onClick,
  outlined,
  hasIcon,
  maxWidth,
  borderRadius,
  fontSize,
  fontWeight,
  height,
  marginBottom
}) {
  const classes = useStyles({
    outlined,
    maxWidth,
    borderRadius,
    fontSize,
    fontWeight,
    height,
    marginBottom
  })

  return (
    <button onClick={onClick} className={classes.button}>
      {children}
      {hasIcon && <IoIosArrowForward size={20} />}
    </button>
  )
}
